module.exports = __webpack_public_path__ + "static/media/backgroundImage.6a19d019.jpg";